import { useQuery } from "@tanstack/react-query";
import { getSubQueryTypes } from "../../service/query/auth";

export const useGetSubQueryTypes = (query_type_id) => {
  return useQuery({
    queryKey: ["subQueryTypes", query_type_id],
    queryFn: () => getSubQueryTypes(query_type_id),
    enabled: !!query_type_id && query_type_id !== "0", // only fetch when a real type is selected
  });
};